import {getEventDisplayName} from '../display-name-registry';

export function getIconForEvent(_event) {
  if (_event?.custom) {
    return `custom`;
  } else if ([`$session_start`, `$session_end`].includes(_event?.value || _event?.name)) {
    return `stop-watch`;
  } else {
    return `event`;
  }
}

export function renameEvent(eventName: string) {
  return getEventDisplayName(eventName);
}
